import { Component, OnInit, Input, ViewChild, OnChanges, AfterContentInit, SimpleChanges } from '@angular/core';
import {DataSource} from '@angular/cdk';
import {MdTable} from '@angular/material';
import {MdPaginator} from '@angular/material';
import {MdSort} from '@angular/material';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';

import { Artikel } from '../models/artikel.model';
/** ------------------------------------------------------------------------------------------- */
@Component({
  selector: 'sws-artikeltabelle',
  templateUrl: './artikeltabelle.component.html',
  styleUrls: ['./artikeltabelle.component.css']
})
export class ArtikeltabelleComponent implements OnInit, OnChanges, AfterContentInit {
/**
   * @input gefundeneArtikel - die Artikel[] - Liste die übergeben wurde
   */
  @Input() gefundeneArtikel: Artikel[] ;


  displayedColumns = ['artikelNr', 'bezeichnung1', 'eigenschaften', 'lhm_bestand', 'bestand'];
  productDatabase: artikelDatabase;

  dataSource: artikelDataSource | null;

  @ViewChild(MdPaginator) paginator: MdPaginator;


  constructor() { }

  ngOnInit() {
    this.productDatabase = new artikelDatabase();
  
  }
  ngOnChanges(changes: SimpleChanges) {
    if ( this.gefundeneArtikel )    {
        console.log("ngOnChanges-Start: gefundene Artikel: " + this.gefundeneArtikel.length);
    }
    console.log("ngOnChanges aufgerufen");
    for (let propName in changes) {
      let chng = changes[propName];
      let cur  = JSON.stringify(chng.currentValue);
      let prev = JSON.stringify(chng.previousValue);
      console.log(`${propName}: currentValue = ${cur}, previousValue = ${prev}`);
    }
    if ( this.gefundeneArtikel )    {
        console.log("ngOnChanges-Ende: gefundene Artikel: " + this.gefundeneArtikel.length);
    }

   
  }
  ngAfterContentInit() {
    console.log("ngAfterContentInit aufgerufen");
    if ( this.gefundeneArtikel)
    {
      console.log("ngAfterContentInit: gefundene Artikel: " + this.gefundeneArtikel.length.toString());
      this.productDatabase.fillDataBase(this.gefundeneArtikel);
      this.dataSource = new artikelDataSource(this.productDatabase, this.paginator);
    }
  }
}

/** ------------------------------------------------------------------------------------------- */
/** An product database that the data source uses to retrieve data for the table.               */
/** Eine Artikel Datenbank die die data source verwendet, um die Daten für die Tabelle zu laden */
export class artikelDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<Artikel[]> = new BehaviorSubject<Artikel[]>([]);
  get data(): Artikel[] { return this.dataChange.value; }

  public artikelListe: Artikel[];

  constructor() {
  }

  fillDataBase(gefundeneArtikel: Artikel[]): void {
    // Fill up the database with products.
    gefundeneArtikel.forEach(einArtikel => {
            /** Adds a product to the database. */
             const copiedData = this.data.slice();
             copiedData.push(einArtikel);
             this.dataChange.next(copiedData);
              })
    
  }
  
}

/** ------------------------------------------------------------------------------------------- */
/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class artikelDataSource extends DataSource<any> {
  constructor(private _artikelDatabase: artikelDatabase, private _paginator: MdPaginator) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Artikel[]> {
    const displayDataChanges = [
      this._artikelDatabase.dataChange,
      this._paginator.page,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._artikelDatabase.data.slice();

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex, this._paginator.pageSize);
    });
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/artikeltabelle/artikeltabelle.component.ts